import { createSlice } from "@reduxjs/toolkit";

export const LANGUAGE = 'userpref/LANGUAGE';
export const LANG_KR = 'userpref/LANG/KR';
export const LANG_EN = 'userpref/LANG/EN';

const prefInitialState = {
    lang: LANG_KR
};

const prefSlice = createSlice({
    name: 'preference'
    , initialState: prefInitialState
    , reducers: {
        setPrefLang: {
            reducer: (state, action) => {
                state.lang = action.payload.lang;
            }
            , prepare: ({lang}) => {
                return({payload: {lang}});
            }
        }
    } 
});

export const toggleLang = (lang) => {
    if(lang === LANG_KR){
        return({type: LANGUAGE, lang: LANG_EN});
    }
    else{
        return({type: LANGUAGE, lang: LANG_KR});
    }
}

export const { setPrefLang } = prefSlice.actions;

export default prefSlice.reducer;
